(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ux-contact-form"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[id^="ContactToggle-"]').forEach((btn) => {
  const target = document.getElementById(btn.getAttribute('aria-controls'));
  if (!target) return;
  btn.addEventListener('click', async () => {
    btn.style.overflow = 'hidden';
    await Motion.animate(
      btn,
      { opacity: [1, 0], height: [btn.offsetHeight + 'px', '0px'], marginBottom: ['1.5rem', '0px'] },
      { duration: 0.2, easing: [0.25, 0, 0, 1] }
    ).finished;
    btn.remove();
    await Motion.animate(target, { height: ['0px', target.scrollHeight + 'px'] }, { duration: 0.35, easing: [0.25, 0, 0, 1] }).finished;
    target.style.height = 'auto';
    target.style.overflow = '';
  }, { once: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ux-customer-gallery"] && !Shopify.designMode) return;
  try {
    
class CustomerGallery extends HTMLElement {
  connectedCallback() {
    const slider = this.querySelector('slider-element');
    customElements.whenDefined('slider-element').then(() => {
      this._updateAlignment();
      if (slider) this._setupLooping(slider);
      this._initAutoplay();
    });
    this._ro = new ResizeObserver(() => this._updateAlignment());
    this._ro.observe(this);
  }

  _updateAlignment() {
    const slider = this.querySelector('slider-element');
    if (!slider) return;
    requestAnimationFrame(() => {
      slider.classList.toggle('is-centered', !slider.isScrollable);
    });
  }

  _setupLooping(slider) {
    // Prevent updateButtons() from ever dispatching disable events
    Object.defineProperty(slider, 'looping', { get: () => true });

    // Monkey-patch for direct calls (e.g. autoplay tick)
    const origNext = slider.next.bind(slider);
    const origPrev = slider.previous.bind(slider);

    slider.next = () => {
      if (slider.currentPage >= slider.itemsToShow.length) {
        slider.select(0, true);
      } else {
        origNext();
      }
    };

    slider.previous = () => {
      if (slider.currentPage <= 1) {
        slider.select(slider.itemsToShow.length, true);
      } else {
        origPrev();
      }
    };

    // The slider registers its event listeners as direct function references at init
    // time, so the instance monkey-patch above doesn't intercept button-click events.
    // Capture the events on this ancestor element before they reach the slider.
    this.addEventListener('slider:next', (e) => {
      if (e.target !== slider) return;
      if (slider.currentPage >= slider.itemsToShow.length) {
        e.stopImmediatePropagation();
        slider.select(0, true);
      }
    }, { capture: true });

    this.addEventListener('slider:previous', (e) => {
      if (e.target !== slider) return;
      if (slider.currentPage <= 1) {
        e.stopImmediatePropagation();
        slider.select(slider.itemsToShow.length, true);
      }
    }, { capture: true });
  }

  _initAutoplay() {
    const slider = this.querySelector('slider-element[data-autoplay]');
    if (!slider) return;

    const speed = parseInt(slider.dataset.autoplaySpeed) || 5000;
    const tick = () => slider.next();

    this._iv = setInterval(tick, speed);
    slider.addEventListener('mouseenter', () => clearInterval(this._iv), { passive: true });
    slider.addEventListener('mouseleave', () => { this._iv = setInterval(tick, speed); }, { passive: true });
  }

  disconnectedCallback() {
    clearInterval(this._iv);
    this._ro?.disconnect();
  }
}

if (!customElements.get('customer-gallery')) {
  customElements.define('customer-gallery', CustomerGallery);
}

  } catch(e) { console.error(e); }
})();
})();
